/**
 * フッターコンポーネント
 */
export class Footer {
  constructor(parentElement: HTMLElement) {
    parentElement.className = "footer";

    parentElement.appendChild(
      document.createTextNode("\u00A9 2026 Questile \u2014 ")
    );

    const link = document.createElement("a");
    link.href = "https://github.com/emtsubasa/questile";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = "GitHub";
    parentElement.appendChild(link);
  }
}
